import React from 'react'
import { Outlet } from 'react-router-dom'
import { Icon, NavBar } from '../../../components'
import { IconBuddy } from '../components'
import '../index.css'

const App = ({ appName }) => {

  const links = [
    {
      type: "link",
      relativePath: "",
      label: "Hem",
      icon: <Icon name="home" />,
    },
    {
      type: "section",
      label: "Vyer",
      links: [
        {
          type: "link",
          relativePath: "generate",
          label: "Generera runda",
          icon: <IconBuddy name="generate" />,
        },
        {
          type: "link",
          relativePath: "history",
          label: "Historik",
          icon: <IconBuddy name="history" />,
        },
      ],
    },
  ]

  return (
    <div className={"app-container" + (appName ? " " + appName : "")}>

      <NavBar links={links} appName={appName} />

      <div className="app-content">
        <Outlet context={appName} />
      </div>

    </div>
  )
}

export default App
